import { gql } from '@apollo/client';

export const INSERT_DISCUSSION_THREAD = gql`
  mutation insertDiscussionThread($input: DiscussionThreadInput!) {
    insertDiscussionThread(input: $input) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      customerId
      title
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      user {
        account {
          name
        }
      }
      customer {
        name
      }
    }
  }
`;

export const INSERT_DISCUSSION_THREAD_MERCHANT = gql`
  mutation createDiscussionThread($input: DiscussionThreadInput!) {
    createDiscussionThread(input: $input) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      userId
      title
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      user {
        account {
          name
        }
      }
    }
  }
`;

export const GET_DISCUSSION_THREAD_LIST = gql`
  query getDiscussionThreadFilteredList(
    $limit: Int
    $offset: Int
    $search: DiscussionThreadSearchInput
    $searchAny: DiscussionThreadSearchInput
    $sortDirection: SortDirection
    $sortField: DiscussionThreadSortField
  ) {
    getDiscussionThreadFilteredList(
      limit: $limit
      offset: $offset
      search: $search
      searchAny: $searchAny
      sortDirection: $sortDirection
      sortField: $sortField
    ) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      userId
      customerId
      paymentLinkType
      title
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      upvoteCount
      customer {
        name
      }
      user {
        account {
          name
        }
      }
    }
  }
`;

export const GET_DISCUSSION_THREAD_LIST_MERCHANT = gql`
  query getDiscussionThreadListMerchant(
    $paymentLinkId: ID
    $courseSectionId: ID
    $courseModuleId: ID
    $isPinned: Boolean
    $status: DiscussionStatus
    $sortDirection: SortDirection
    $sortField: DiscussionThreadSortField
    $cursor: Timestamp
    $searchQuery: String
    $limit: Int
  ) {
    getDiscussionThreadListMerchant(
      paymentLinkId: $paymentLinkId
      courseSectionId: $courseSectionId
      courseModuleId: $courseModuleId
      isPinned: $isPinned
      status: $status
      sortDirection: $sortDirection
      sortField: $sortField
      cursor: $cursor
      searchQuery: $searchQuery
      limit: $limit
    ) {
      items {
        id
        paymentLinkId
        courseSectionId
        courseModuleId
        userId
        customerId
        paymentLinkType
        title
        content
        status
        isPinned
        editedAt
        editCount
        createdAt
        updatedAt
        upvoteCount
        repliesCount
        customer {
          name
        }
        user {
          account {
            name
          }
        }
        userVote {
          type
        }
      }
      hasMore
      nextCursor
    }
  }
`;

export const GET_DISCUSSION_REPLY_LIST_MERCHANT = gql`
  query getDiscussionReplyListMerchant(
    $discussionThreadId: ID!
    $isPinned: Boolean
    $status: DiscussionStatus
    $cursor: Timestamp
    $limit: Int
  ) {
    getDiscussionReplyListMerchant(
      discussionThreadId: $discussionThreadId
      isPinned: $isPinned
      status: $status
      cursor: $cursor
      limit: $limit
    ) {
      items {
        id
        discussionThreadId
        userId
        customerId
        content
        status
        isPinned
        editedAt
        editCount
        createdAt
        updatedAt
        upvoteCount
        customer {
          name
        }
        user {
          account {
            name
          }
        }
        userVote {
          type
        }
      }
      hasMore
      nextCursor
    }
  }
`;

export const VOTE_DISCUSSION_THREAD = gql`
  mutation voteDiscussionThread($id: ID!, $type: DiscussionVoteType!) {
    voteDiscussionThread(id: $id, type: $type) {
      id
      upvoteCount
    }
  }
`;

export const PIN_DISCUSSION_THREAD = gql`
  mutation editDiscussionThread($input: DiscussionThreadInput!) {
    editDiscussionThread(input: $input) {
      id
      isPinned
    }
  }
`;

export const LOCK_DISCUSSION_THREAD = gql`
  mutation editDiscussionThread($input: DiscussionThreadInput!) {
    editDiscussionThread(input: $input) {
      id
      status
    }
  }
`;

export const MARK_DISCUSSION_THREAD_ANSWERED = gql`
  mutation editDiscussionThread($input: DiscussionThreadInput!) {
    editDiscussionThread(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_DISCUSSION_THREAD = gql`
  mutation removeDiscussionThread($id: ID!) {
    removeDiscussionThread(id: $id)
  }
`;

export const EDIT_DISCUSSION_THREAD = gql`
  mutation updateDiscussionThread($input: DiscussionThreadInput!) {
    updateDiscussionThread(input: $input) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      userId
      customerId
      paymentLinkType
      title
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      upvoteCount
    }
  }
`;

export const GET_DISCUSSION_THREAD = gql`
  query getDiscussionThread($id: ID!) {
    getDiscussionThread(id: $id) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      userId
      customerId
      paymentLinkType
      title
      content
      status
      isPinned
      editedAt
      editCount
      upvoteCount
      downvoteCount
      createdAt
      updatedAt
      user {
        account {
          name
        }
      }
      customer {
        name
      }
    }
  }
`;

export const GET_DISCUSSION_THREAD_MERCHANT = gql`
  query getDiscussionThreadMerchant($id: ID!) {
    getDiscussionThreadMerchant(id: $id) {
      id
      paymentLinkId
      courseSectionId
      courseModuleId
      userId
      customerId
      paymentLinkType
      title
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      upvoteCount
      customer {
        name
      }
      user {
        account {
          name
        }
      }
      repliesCount
      userVote {
        type
      }
    }
  }
`;

export const INSERT_DISCUSSION_THREAD_REPLY = gql`
  mutation createDiscussionThreadReply($input: DiscussionThreadReplyInput!) {
    createDiscussionThreadReply(input: $input) {
      id
      discussionThreadId
      userId
      customerId
      content
      status
      isPinned
      editedAt
      editCount
      createdAt
      updatedAt
      user {
        account {
          name
        }
      }
      customer {
        name
      }
    }
  }
`;

export const VOTE_DISCUSSION_THREAD_REPLY = gql`
  mutation voteDiscussionThreadReply($id: ID!, $type: DiscussionVoteType!) {
    voteDiscussionThreadReply(id: $id, type: $type) {
      id
      upvoteCount
    }
  }
`;
export const PIN_DISCUSSION_THREAD_REPLY = gql`
  mutation editDiscussionThreadReply($input: DiscussionThreadReplyInput!) {
    editDiscussionThreadReply(input: $input) {
      id
      isPinned
    }
  }
`;

export const DELETE_DISCUSSION_THREAD_REPLY = gql`
  mutation removeDiscussionThreadReply($id: ID!) {
    removeDiscussionThreadReply(id: $id)
  }
`;

export const EDIT_DISCUSSION_THREAD_REPLY = gql`
  mutation updateDiscussionThreadReply($input: DiscussionThreadReplyInput!) {
    updateDiscussionThreadReply(input: $input) {
      id
      content
      status
      isPinned
      editedAt
      editCount
      updatedAt
    }
  }
`;

export const BAN_CUSTOMER_FROM_DISCUSSION = gql`
  mutation banCustomerFromDiscussion($paymentLinkId: ID!, $customerId: ID!, $isBanned: Boolean!, $reason: String!) {
    banCustomerFromDiscussion(
      paymentLinkId: $paymentLinkId
      customerId: $customerId
      isBanned: $isBanned
      reason: $reason
    )
  }
`;

export const GET_DISCUSSION_BAN_LIST = gql`
  query getDiscussionBanFilteredList($search: DiscussionBanSearchInput) {
    getDiscussionBanFilteredList(search: $search) {
      id
      userId
      customerId
      paymentLinkId
      unbannedAt
      reason
    }
  }
`;

export const GET_DISCUSSION_THREAD_PARTICIPANT_LIST = gql`
  query getDiscussionThreadParticipantFilteredList($search: DiscussionThreadParticipantSearchInput) {
    getDiscussionThreadParticipantFilteredList(search: $search) {
      id
      discussionThreadId
      userId
      customerId
      isSubscribed
      user {
        account {
          name
          email
        }
      }
      customer {
        name
        email
      }
    }
  }
`;

export const EDIT_DISCUSSION_THREAD_PARTICIPANT = gql`
  mutation editDiscussionThreadParticipant($input: DiscussionThreadParticipantInput) {
    editDiscussionThreadParticipant(input: $input) {
      id
      isSubscribed
    }
  }
`;
